// extracted by mini-css-extract-plugin
module.exports = {"container":"text-input_container__cXawq","label":"text-input_label__aawEM","text-input":"text-input_text-input__ulBQn"};